// src/services/apiService.js
import EquityService from './equityService';
import DataroomService from './dataroomService';
import UtilityService from './utilityService';
import UserAnalyticsService from './userAnalyticsService';

// Main API service that combines all service modules
const ApiService = {
  // Equity Manager services
  ...EquityService,
  
  // Dataroom services  
  ...DataroomService,
  
  // Utility services
  ...UtilityService,
  
  // ===========================================
  // User Analytics
  // ===========================================
  fetchUserAnalytics: async () => {
    return await UserAnalyticsService.fetchUserStats();
  },
  
  fetchActivityAnalytics: async () => {
    return await UserAnalyticsService.fetchActivityStats();
  },
  
  fetchFeatureUsage: async () => {
    return await UserAnalyticsService.fetchFeatureUsage();
  },
  
  fetchUserJourney: async () => {
    return await UserAnalyticsService.fetchUserJourney();
  },
  
  fetchPageAnalytics: async (days = 30) => {
    return await UserAnalyticsService.fetchPageAnalytics(days);
  },

  // ===========================================
  // Director Notifications (from equity manager)
  // ===========================================
  sendDirectorNotifications: async (companyId, directorIds) => {
    try {
      const headers = await UtilityService.getAuthHeaders();
      const response = await fetch('/api/notify-directors', {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
          company_id: companyId,
          director_ids: directorIds,
        }),
      });
      return UtilityService.handleResponse(response);
    } catch (error) {
      console.error('Error sending director notifications:', error);
      throw error;
    }
  },

  // ===========================================
  // Health Check
  // ===========================================
  healthCheck: async () => {
    try {
      const response = await fetch('/api/health');
      return UtilityService.handleResponse(response);
    } catch (error) {
      console.error('Health check failed:', error);
      throw error;
    }
  }
};

export default ApiService;

// Export individual services for direct access
export { EquityService, DataroomService, UtilityService };

// Also export as named exports for backward compatibility
export const dataroomService = DataroomService;
export const equityService = EquityService;
export const utilityService = UtilityService;